/**
 * Gallery prev/next arrows, overlaid on the main image. Additive to the
 * existing thumbnail strip, not a replacement.
 *
 * Deliberately doesn't reimplement carousel logic or edit main-product.liquid
 * (a large file shared by every product on the site) — <scroll-carousel>
 * already exposes a public API (cells / selectedIndex / select()) that the
 * thumbnails themselves use, so the arrows just call the same method. That
 * also means clicking an arrow updates the thumbnail strip's active state
 * automatically, since select() dispatches the same carousel:select event
 * the thumbnails already listen for.
 */
function initGalleryArrows() {
  const gallery = document.querySelector('.shopify-section--main-product product-gallery');
  const carousel = gallery?.querySelector('scroll-carousel');
  const imageList = gallery?.querySelector('.product-gallery__image-list');
  if (!gallery || !carousel || !imageList || gallery.dataset.arrowsAdded) return;

  // When auto-rotate is on, snippets/product-gallery.liquid renders its own
  // overlay arrows (driven by product-gallery-autorotate.js, which also needs
  // their clicks to halt rotation). Adding a second pair here would stack two
  // sets of arrows on the same image — and clicking this pair would move the
  // carousel without ever stopping the timer, so the gallery would keep
  // rotating out from under the shopper. Defer to the native ones instead;
  // pdp-custom.css styles both pairs identically, so this is invisible.
  if (gallery.querySelector('[data-gallery-autorotate-prev]')) return;

  gallery.dataset.arrowsAdded = 'true';

  function makeArrow(direction, label, pathD) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `gallery-nav-arrow gallery-nav-arrow--${direction}`;
    button.setAttribute('aria-label', label);
    button.innerHTML = `<svg width="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="${pathD}" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/></svg>`;
    return button;
  }

  const prevButton = makeArrow('prev', 'Previous image', 'M7 1 3 5l4 4');
  const nextButton = makeArrow('next', 'Next image', 'm3 9 4-4-4-4');

  function goTo(step) {
    const cellCount = carousel.cells.length;
    if (cellCount === 0) return;
    const nextIndex = (carousel.selectedIndex + step + cellCount) % cellCount;
    carousel.select(nextIndex);
  }

  prevButton.addEventListener('click', () => goTo(-1));
  nextButton.addEventListener('click', () => goTo(1));

  imageList.appendChild(prevButton);
  imageList.appendChild(nextButton);
}

document.addEventListener('DOMContentLoaded', initGalleryArrows);
